var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.character ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Character')
    }
  })], 1) : _c('div', [_c('div', {
    key: "original-character-icon-".concat(_vm.id),
    staticClass: "float-right px-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.$asset.originalcharactericon.format(_vm.id) + '.png',
      "target": "_blank"
    }
  }, [_c('CharaIcon', {
    attrs: {
      "original": "",
      "id": _vm.id,
      "size": _vm.$size(64)
    }
  })], 1)]), _c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$name(_vm.character.m_Title, true)))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale != 'ja',
      expression: "$i18n.locale!='ja'"
    }],
    staticClass: "px-4"
  }, [_c('span', [_vm._v("日本語：")]), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.character.m_Title))])]), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('p', {
    class: {
      small: _vm.$vuetify.breakpoint.xsOnly
    },
    domProps: {
      "innerHTML": _vm._s(_vm.character.m_Descript.replace(/\n/g, '<br>'))
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Illustrator'),
      "v": _vm.character.m_Illustrator,
      "width": "33%"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('CV'),
      "v": _vm.character.m_CV,
      "width": "33%"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }